import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { AuthShell, authInput, authButton } from "@/components/auth/AuthShell";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      eyebrow="Account Recovery"
      title="Set a new password"
      image="https://images.unsplash.com/photo-1631049307264-da0ec9d70304?crop=entropy&cs=srgb&fm=jpg&q=85"
    >
      {!token ? (
        <p className="font-sans text-sm text-[var(--aur-text-2)]">This reset link is invalid or missing a token.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <input type="password" required minLength={6} placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} className={authInput} data-testid="reset-password" />
          <button type="submit" disabled={loading} className={authButton} data-testid="reset-submit">
            {loading ? "Updating…" : "Update Password"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
